import React from 'react';

import { graphql, withApollo, compose } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';
import TablaDocumentos from './TablaDocumentos';
import { message } from 'antd/lib';

import getDocumentosPDF from '../../../graphql/querys/documentos/getDocumentosPDF.graphql';
import getBase64 from '../../../graphql/querys/documentos/getBase64.graphql';
import deleteDocumentoPDF from '../../../graphql/mutations/documentos/deleteDocumentoPDF.graphql';

import convertBase64toBlob from './convertBase64toBlob';

@compose(
  graphql(deleteDocumentoPDF, {
    name: 'deleteDocumentoPDF',
  })
)
class Documentos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      documentos: [],
      currentPage: 1,
      pagina: 1,
      cantidadPorPagina: 10,
      cantidadTotal: 0,
      loadingTabla: false,
    };

    this.getBase64 = this.getBase64.bind(this);
    this.generatePDF = this.generatePDF.bind(this);
  }

  componentDidMount() {
    this.getDocumentos();
  }

  eliminarElementoLista = id => {
    let lista = [...this.state.documentos];

    let removidos = _.remove(lista, elem => {
      return elem._id == id;
    });

    this.setState(
      {
        ...this.state,
        documentos: lista,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  ordenarLista = (numPagina, tamPagina) => {
    this.setState({
      loadingTabla: true,
    });
    let listaOrdenada = _.orderBy(
      this.state.documentos,
      [
        doc => {
          return doc.fechaSubida;
        },
      ],
      ['desc']
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      documentos: listaOrdenada,
      loadingTabla: false,
    });
  };

  handleDelete = id => {
    this.props
      .deleteDocumentoPDF({
        variables: {
          _id: id,
        },
      })
      .then(res => {
        // console.log('Documento eliminado', res);
        message.success('Documento eliminado exitosamente');
        this.eliminarElementoLista(id);
      })
      .catch(err => {
        // console.log('Error eliminando el documento', err);
        message.error('Error eliminando el documento');
      });
  };

  getDocumentos() {
    // console.log('VOY A LLAMAR GET DOCUMENTOS');
    // console.log('estado antes de llamar', this.state);

    this.setState({ loadingTabla: true });
    this.props.client
      .query({
        query: getDocumentosPDF,
        fetchPolicy: 'network-only',
      })
      .then(res => {
        // console.log('Respuesta getDocumentos', res);
        this.setState(
          {
            ...this.state,
            documentos: res.data.getDocumentosPDF,
            cantidadTotal: res.data.getDocumentosPDF.length,
            loadingTabla: false,
          },
          function() {
            this.ordenarLista(this.state.pagina, this.state.cantidadPorPagina);
          }
        );
      })
      .catch(err => {
        console.log('ERROR EN EL PEDIDO DE DOCUMENTOS');
        console.log(err);
      });
  }

  getBase64(archivoId) {
    this.props.client
      .query({
        query: getBase64,
        variables: {
          archivo: archivoId,
        },
      })
      .then(res => {
        // console.log('response getBase64', res);
        return this.generatePDF(archivoId, res.data.getBase64);
      })
      .catch(err => {
        console.log('ERROR AL OBTENER EL LINK');
        console.log(err);
      });
  }

  generatePDF(archivoId, data) {
    const base64PdfBlob = convertBase64toBlob(data, 'application/pdf');
    const filePdf = URL.createObjectURL(base64PdfBlob);
    window.open(filePdf);
  }

  render() {
    const cambiarPagina = pagina => {
      this.setState(
        {
          pagina: pagina,
        },
        () => {
          // console.log('CAMBIE A LA PAGINA: ', pagina);
          this.getDocumentos();
        }
      );
    };

    const cambiarTamañoPagina = tamaño => {
      // console.log('ESTADO', this.state);
      this.setState({
        cantidadPorPagina: tamaño,
      });
    };

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.documentos ? this.state.documentos.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };

    return (
      <div>
        <TablaDocumentos
          documentos={this.state.documentos}
          pagina={this.state.pagina}
          pagination={pagination}
          tamañoPagina={this.state.cantidadPorPagina}
          cantidadPorPagina={this.state.cantidadPorPagina}
          cambiarTamañoPagina={cambiarTamañoPagina}
          total={this.state.cantidadTotal}
          loadingTabla={this.state.loadingTabla}
          cambiarPagina={cambiarPagina}
          handleDelete={this.handleDelete}
          usuario={this.props.usuario}
          getBase64={this.getBase64}
        />
      </div>
    );
  }
}

export default withApollo(Documentos);
